import React from 'react';
import PropTypes from 'prop-types';
import Portal from '@spothero/ui/portal';
import SHLoader from 'common/loader/SHLoader';
import SpotImagesMobile from 'spot-details/details/SpotImagesMobile';
import ShuttleInformation from './shuttle/ShuttleInformation';
import BenefitMessage from './header/BenefitMessage';
import SpotDetailsHeader from './header/SpotDetailsHeader';
import FacilityLocation from './FacilityLocation';
import SafetyAmenities from './SafetyAmenities';
import ThingsYouShouldKnow from '../details/ThingsYouShouldKnow';
import HowToRedeemArrivalDeparture from './HowToRedeemArrivalDeparture';
import FAQPanels from 'spot-details/footer/FAQPanels';
import TrustSealValueProps from 'spot-details/footer/TrustSealValueProps';
import AirportPurchaseInformation from './purchase/AirportPurchaseInformation';
import AirportPurchaseSnapshot from './purchase/AirportPurchaseSnapshot';

const SpotDetailsAirportContentRedesign = ({
    isMobile,
    currencyType,
    isMonthly,
    starts,
    ends,
    updateSearchTimes,
    fetchAirportRates,
    isLoading,
    pushTo,
    isAirportRateUnavailable,
    updateSelectedSpot,
    facility,
    comparisons,
    distanceInMiles,
    selectedRate,
    onCheckoutClick,
}) => {
    const {
        airport,
        cancellation_allowed: cancellationAllowed,
        amenities_full: amenities,
        rating_info: ratingInfo,
    } = facility;
    const {
        details: {code: iataCode},
        shuttle,
        lowest_daily_rate: lowestDailyRate,
    } = airport;

    if (isLoading || !facility) {
        return <SHLoader className="SpotDetailsAirport-loader" />;
    }

    return (
        <div className="SpotDetailsAirport AirportContentRedesign">
            <div className="SpotDetailsAirport-panels AirportContentRedesign-main-content">
                <BenefitMessage
                    comparisons={comparisons}
                    iataCode={iataCode}
                    ratingInfo={ratingInfo}
                />
                <SpotImagesMobile
                    className="AirportContentRedesign-header-carousel"
                    images={facility.images}
                    alt={facility.title}
                    height={335}
                    width={629}
                    showDots={false}
                    showArrows={!isMobile}
                    showPageNumbers
                />
                <SpotDetailsHeader
                    facility={facility}
                    comparisons={comparisons}
                />
                <ShuttleInformation
                    shuttle={shuttle}
                    facilityTitle={facility.title}
                    iataCode={iataCode}
                />
                <FacilityLocation
                    facility={facility}
                    distanceInMiles={distanceInMiles}
                />
                <SafetyAmenities amenities={amenities} />
                <ThingsYouShouldKnow
                    rate={selectedRate}
                    facility={facility}
                    isMonthly={isMonthly}
                    // eslint-disable-next-line no-empty-function
                    onShowRateDetailsClick={() => {}}
                />
                <HowToRedeemArrivalDeparture
                    selectedRate={selectedRate}
                    facility={facility}
                />
                <FAQPanels cancellationAllowed={cancellationAllowed} />
                <TrustSealValueProps />
            </div>
            {isMobile ? (
                <Portal>
                    <AirportPurchaseSnapshot
                        cancellationAllowed={cancellationAllowed}
                        availableTransientInventory={
                            facility.available_transient_inventory
                        }
                        displayPrice={
                            selectedRate
                                ? selectedRate.display_price
                                : lowestDailyRate
                        }
                        currencyType={currencyType}
                        checkoutDisabled={!selectedRate}
                        onCheckoutClick={onCheckoutClick}
                    />
                </Portal>
            ) : (
                <div className="AirportContentRedesign-checkout">
                    <AirportPurchaseInformation
                        onCheckoutClick={onCheckoutClick}
                        facility={facility}
                        selectedRate={selectedRate}
                        starts={starts}
                        ends={ends}
                        availableTransientInventory={
                            facility.available_transient_inventory
                        }
                        fetchRates={fetchAirportRates}
                        updateSearchTimes={updateSearchTimes}
                        isAirportRateUnavailable={isAirportRateUnavailable}
                        isFetchingRates={isLoading}
                        pushTo={pushTo}
                        updateSelectedSpot={updateSelectedSpot}
                        isRedesign
                    />
                </div>
            )}
        </div>
    );
};

SpotDetailsAirportContentRedesign.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    currencyType: PropTypes.string,
    isMonthly: PropTypes.bool,
    starts: PropTypes.string,
    ends: PropTypes.string,
    updateSelectedSpot: PropTypes.func,
    updateSearchTimes: PropTypes.func,
    fetchAirportRates: PropTypes.func,
    isLoading: PropTypes.bool,
    pushTo: PropTypes.func,
    isAirportRateUnavailable: PropTypes.bool,
    facility: PropTypes.object,
    comparisons: PropTypes.object,
    distanceInMiles: PropTypes.number,
    selectedRate: PropTypes.object,
    onCheckoutClick: PropTypes.func,
};

export default SpotDetailsAirportContentRedesign;
